import script from "./StatusAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusAlert.vue?vue&type=script&setup=true&lang=js"

import "./StatusAlert.vue?vue&type=style&index=0&id=75c571c0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75c571c0"]])

export default __exports__